export default "__VITE_ASSET__23a07b33__"